import React from 'react';
import SectionBasePage from 'components/SectionBasePage';
import { Tabs } from 'UI';
import { useOrganizationContext } from 'hooks/contextOrganization';
import { useRootPage } from 'hooks/breadcrumb';
import { ROUTES } from 'constants/routes';

import {
  // ProposalsTab,
  // OrdersTab,
  SeedingProductionItemsTab,
  SeedingListTab,
} from './Tabs';

// import {
//   Extra,
// } from './components';

enum TabKeys {
  // SCHEDULED = 'SCHEDULED',
  // ORDERS = 'ORDERS',
  PRODUCTION_ITEMS = 'PRODUCTION_ITEMS',
  SEEDING_LIST = 'SEEDING_LIST',
}

// interface RootPageProps {
//   onOrderCopy: (orderId: string) => void
// }

const RootPage = (): JSX.Element => {
  // const breadcrumbNavigator = useBreadcrumbNavigation();
  // const { url } = useRouteMatch();

  // const resourcesAction = () => breadcrumbNavigator.push({
  //   label: 'Cadastro',
  //   url: `${url}${ROUTES.dashboard.inventory.resource.root}`,
  // });

  // const organizationInventoryAction = () => breadcrumbNavigator.push({
  //   label: 'Viveiro',
  //   url: `${url}${ROUTES.dashboard.inventory.organization.root}`,
  // });

  // const clientInventoryAction = () => breadcrumbNavigator.push({
  //   label: 'Clientes',
  //   url: `${url}${ROUTES.dashboard.inventory.client.root}`,
  // });

  useRootPage({
    label: 'Semeio',
    url: ROUTES.seeding.root,
  });

  const organizationContext = useOrganizationContext();

  return (
    <SectionBasePage
      title={`Semeios ${organizationContext.organization?.name || ''}`}
      // extra={<Extra />}
    >
      <>
        {organizationContext.organization ? (
          <Tabs
            destroyInactiveTabPane
          >
            {/* <Tabs.TabPane tab="Propostas" key={TabKeys.SCHEDULED}>
              <ProposalsTab
                onOrderCopy={onOrderCopy}
                selectedOrg={organizationContext.organization}
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Pedidos" key={TabKeys.ORDERS}>
              <OrdersTab
                onOrderCopy={onOrderCopy}
                selectedOrg={organizationContext.organization}
              />
            </Tabs.TabPane> */}
            <Tabs.TabPane tab="Itens de Produção" key={TabKeys.PRODUCTION_ITEMS}>
              <SeedingProductionItemsTab
                selectedOrg={organizationContext.organization}
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Lista de Semeio" key={TabKeys.SEEDING_LIST}>
              <SeedingListTab
                selectedOrg={organizationContext.organization} // Should filter by org?
              />
            </Tabs.TabPane>
          </Tabs>
        ) : (
          <></>
        )}
      </>
    </SectionBasePage>
  );
};

export default RootPage;
